import { getParam } from '../redux/helpers/getParams';
import { postTextData } from '../redux/helpers/texts';
import { addText } from '../redux/actions/entities/texts';
import { addTextToPage } from '../redux/actions/entities/pages';
import { getRatio } from '../redux/helpers/index';


export const BOYTEXTCOLOR = '#57bbfb';
export const GIRLTEXTCOLOR = '#f7a9c1';
export const DEFAULT_INSERTED_BOY_COLOR = '#0d659c';
export const DEFAULT_INSERTED_GIRL_COLOR = '#c1909f';
const FONT = 'DJB_Baby_Bump';
const DEFAULTTEXTPROPS = {
  fontSize: 50,
  font: FONT,
  shadow: false,
  stroke: false,
  strokeColor: '',
  isMoveable: false,
  isSpine: false,
  context: getParam('context'),
};


export function mergeDefaultData(bookId) {
  return Object.assign(DEFAULTTEXTPROPS, { bookId });
}

function getSelectorLimitCoords(selector) {
  return document.querySelector(selector).getBoundingClientRect();
}

export async function generateText(textProperties, pageId, textId, dispatch) {
  return new Promise(async (resolve) => {
    await dispatch(addText(textProperties));
    const posted = await postTextData(textProperties, dispatch);
    if (posted) {
      await dispatch(addTextToPage(pageId, textId));
      resolve(true);
    }
  });
}

export function calculateXYPosition(left, top, layoutHeight, bookHeight) {
  const dragWrapper = getSelectorLimitCoords('.dragLimit');
  const interactiveLayer = getSelectorLimitCoords('.InteractiveLayer');

  return {
    x: ((dragWrapper.left - interactiveLayer.left) + (left * getRatio(layoutHeight, bookHeight))),
    y: (((dragWrapper.top - interactiveLayer.top) + (top * getRatio(layoutHeight, bookHeight)))),
  };
}



// WEBPACK FOOTER //
// ./src/helpers/babyBookHelper.jsx